import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/gemeinschaftsschule/referenzschulen-bw.png")